import { render, staticRenderFns } from "./examCurrentResults.vue?vue&type=template&id=40845803&scoped=true"
import script from "./examCurrentResults.vue?vue&type=script&lang=js"
export * from "./examCurrentResults.vue?vue&type=script&lang=js"
import style0 from "./examCurrentResults.vue?vue&type=style&index=0&id=40845803&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40845803",
  null
  
)

export default component.exports